import React, { useState } from "react";
import "./Story.css";
import "./contentpage.css";

function Story() {
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">The Story Behind Bitcoin Ilm</h1>
        <p className="story-text">
          <p className="story-text">
            Bitcoin Ilm is a knowledge platform built at the intersection of
            faith, finance, and technology. The name itself reflects the
            foundation upon which this initiative stands. <i>Ilm</i> is an
            Arabic noun that means knowledge, but in the Islamic terminology, it
            signifies far more than the accumulation of information. Ilm
            represents understanding that is derived from the sources of revelation, guided by the interpretation of scholars.
          </p>
        </p>
        <h2 className="story-section-title">
          A Personal Journey That Inspired a Platform
        </h2>
        <p className="story-text">
          <p className="story-text">
            Bitcoin Ilm was not conceived as a commercial venture, nor as a
            branding exercise. It was born out of necessity.
            <br />
            As a Muslim who strives to place his deen before all else, my own
            journey toward understanding and adopting Bitcoin was long,
            difficult, and often frustrating. I encountered books, articles,
            podcasts, and videos that convincingly argued that Bitcoin is
            superior money. I encountered other materials that explained, in
            impressive detail, how Bitcoin is a decentralized, censorship
            resistant, and mathematically secure network. Yet despite consuming
            vast amounts of content, I found myself unable to answer the most
            important question of all. How does Bitcoin stand when measured
            against the principles of Islam?
            <br />
            There was no single resource that held my hand and guided me through
            the process. Beginning with Islamic concepts of wealth (mal),
            ownership (milkiyyah), trade (bay‘), the prohibition of riba and
            gharar, the objectives of Islam (maqasid), and the ethics of money,
            before arriving at Bitcoin as a contemporary case study. Instead,
            information was scattered, unstructured, and often perplexing.
            <br />
            This struggle was not unique to me. Friends, family members, and
            fellow Muslims who were curious about Bitcoin experienced the same
            confusion. Many were interested but hesitant, fearful of unknowingly
            compromising their faith. Others dismissed Bitcoin altogether due to
            a lack of clear guidance. It became increasingly evident that the
            Muslim community was in need of a platform that approached Bitcoin
            not as a speculative asset, nor as an ideological movement, but as a
            subject of serious Islamic inquiry.
            <br />
            When it became clear that such a platform did not exist in a
            comprehensive and accessible form, I resolved to build one.
          </p>
        </p>
        <div className="story-divider"></div>
        <h2 className="story-section-title">
          Built for Faithful Adoption, Not Blind Imitation
        </h2>
        <p className="story-text">
          <p className="story-text">
            Bitcoin Ilm was created first and foremost for myself, so that I
            could engage with Bitcoin in a way that did not require sacrificing
            any aspect of my faith. It was then expanded for anyone who finds
            this platform beneficial.
            <br />
            The purpose of this platform is not to persuade Muslims to adopt
            Bitcoin at any cost. Rather, it is to educate them so that any
            decision, whether to adopt, abstain, or remain cautious, is made
            from a place of knowledge rather than ignorance or fear. Islam does
            not demand technological isolation, nor does it permit uncritical
            assimilation. It demands ilm, reflection, consultation, and moral
            responsibility.
            <br />
            At Bitcoin Ilm, Bitcoin is examined across multiple dimensions.
            <table className="trade-table">
              <tbody>
                <tr>
                  <td>It is studied as a form of money and store of value.</td>
                </tr>
                <tr>
                  <td>
                    It is analyzed as a decentralized technological system.
                  </td>
                </tr>
                <tr>
                  <td>
                    It is evaluated as an alternative to interest based fiat
                    currencies.
                  </td>
                </tr>
                <tr>
                  <td>
                    It is explored as a tool that may enable financial
                    sovereignty.
                  </td>
                </tr>
                <tr>
                  <td>
                    It is assessed as a subject of Islamic legal and ethical
                    evaluation.
                  </td>
                </tr>
              </tbody>
            </table>
            Each of these dimensions is explored systematically, with constant
            reference back to Islamic principles, scholarly methodology, and
            historical precedent.
          </p>
        </p>
        <div className="story-divider"></div>
        <h2 className="story-section-title">
          Scholarly Grounding and Responsibility
        </h2>{" "}
        <p className="story-text">
          <p className="story-text">
            The content of Bitcoin Ilm is not the result of fleeting research or
            surface level engagement. It is the culmination of over{" "}
            <b>fifteen years</b> as a student of Islamic sciences, combined with
            more than <b>eighteen months</b> of focused effort dedicated to
            researching, structuring, and building this platform.
            <br />
            Throughout this process, the intention (niyyah) has been singular.
            It is to seek the pleasure of Allah alone by contributing something
            beneficial to the Muslim community. Any goodness, clarity, or
            benefit that emerges from this platform is not attributed to
            personal brilliance, but to the mercy of Allah and the guidance of
            teachers, scholars, and authors whose works have illuminated the
            path.
            <br />
            Credit is due to the scholars from whom I have learned, both
            directly and through their writings, as well as to the authors whose
            works on Islamic jurisprudence, economics, history, computer science
            and monetary theory have been instrumental in shaping the content of
            this platform. Bitcoin Ilm stands on the shoulders of these giants,
            and it makes no claim of originality in matters that are inherited
            from established scholarship.
            <br />
            At the same time, intellectual honesty demands humility. If there
            are shortcomings, errors, or areas requiring refinement, the
            responsibility rests solely with me. I openly welcome correction,
            critique, and constructive feedback, and I remain committed to
            making amendments whenever errors are brought to my attention.
            Knowledge in Islam is a trust (amanah), and safeguarding that trust
            requires accountability.
          </p>
        </p>
        <div className="story-divider"></div>
        <h2 className="story-section-title">
          A Living Platform, Not a Final Verdict
        </h2>
        <p className="story-text">
          <p className="story-text">
            Bitcoin Ilm does not present itself as the final word on Bitcoin and
            Islam. Rather, it is a living educational journey that evolves as
            understanding deepens, scholarship advances, and new questions
            arise. The aim is not to replace scholars or issue definitive
            rulings, but to equip Muslims with the conceptual clarity necessary
            to engage meaningfully with contemporary financial realities.
            <br />
            In a world where money increasingly dictates human dignity, freedom,
            and survival, Muslims cannot afford to remain disengaged or
            uninformed. At the same time, they cannot afford to compromise their
            ethical and spiritual foundations. Bitcoin Ilm exists to help
            navigate this delicate balance.
          </p>
        </p>
        <div className="story-divider"></div>
        <h2 className="story-section-title"> Vision</h2>
        <p className="story-text">
          <p className="story-text">
            The vision of Bitcoin Ilm is to cultivate a generation of Muslims
            who understand money deeply, engage with technology responsibly, and
            remain anchored in their faith, regardless of how complex the world
            becomes. A generation that does not inherit systems blindly, but
            examines them critically through the light of revelation and reason.
            <br />
            If Bitcoin proves to be a tool that aligns with Islamic principles
            and helps Muslims distance themselves from riba and injustice, then
            it deserves serious consideration. If it falls short in certain
            areas, those shortcomings must be acknowledged honestly. Bitcoin Ilm
            exists to facilitate this evaluation with sincerity, depth, and
            integrity.
          </p>
        </p>
        <div className="story-divider"></div>
        <h2 className="story-section-title"> Conclusion</h2>
        <p className="story-text">
          <p className="story-text">
            Bitcoin Ilm is ultimately an invitation. It is an invitation to
            learn, to question, to reflect, and to act with conscience. It is
            for Muslims who refuse to separate faith from finance, ethics from
            economics, or worship from daily life. It is for those who believe
            that knowledge, when pursued sincerely, is a form of worship.
          </p>
          <h2 className="story-section-title">
            9 Rajab 1447 AH (Monday, 29 December 2025)
          </h2>
        </p>
        <div className="story-footer">
          May Allah accept this effort, overlook its shortcomings, and make it a
          means of benefit for all who engage with it.
        </div>
      </div>
    </div>
  );
}

export default Story;
